export default [
  {
    path: '/forms/:id',
    name: 'form',
    component: () => import(/* webpackChunkName: "form" */ './SingleForm'),
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/create-form',
    name: 'create-form',
    component: () => import(/* webpackChunkName: "form" */ './SingleForm'),
    meta: {
      requiresAuth: true
    }
  }
]
